import clsx from 'clsx'
import classes from './ArticleSidebar.module.css'

export function ArticleSidebarHeader({ children }) {
  return <h3 className={clsx('likeH4', classes.sidebarHeader)}>{children}</h3>
}
